import { Pipe, PipeTransform } from '@angular/core';
import {
	getDisplayName,
	User,
	type AuthUser,
} from '@context/shared/types/user';

@Pipe({
	name: 'userName',
	standalone: true,
})
export class UserNamePipe implements PipeTransform {
	transform(user: User | AuthUser | null): string | null {
		if (!user) return null;
		const name = getDisplayName(user);
		return name || null;
	}
}
